import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import ViewableMixin from './ViewableMixin';

var Person = Backbone.Model.extend({
    url: function() {
        return '/api/v2/userProfile/' + this.id;
    },

    parse: function(response, options) {
        if (options.wrap){
            var wrapper = options.wrap;
            wrapper.set('person', response.person);
            return wrapper.toJSON();
        }
        return response.person || response;
    },

    fullName: function() {
        return _.compact([
            this.get('first-name'),
            this.get('last-name')
        ]).join(' ');
    },

    toggleLead: function(eventId, options) {
        var thisModel = this;
        options = options || {};

        if (!eventId || !this.id) {
            options.error && options.error();
            return;
        }

        var myLead = this.get('myLead') || false;

        var success = options.success;
        options.success = function() {
            thisModel.set('myLead', !myLead);
            success && success();
        };

        var toggleMethod = myLead? 'DELETE' : 'POST';
        var toggleUrl = '/api/v1/person/~/opportunities' + (myLead ? '/' + this.id + '/' + eventId : '');

        Backbone.ajax({
            url: toggleUrl,
            method: toggleMethod,
            success: options.success,
            error: options.error,
            data: {
                'opportunity': {
                    'target-person-id': this.id,
                    'event-id': eventId
                }
            }
        });
    }
});
_.extend(Person.prototype, ViewableMixin);

export default Person;

